import { format, parseISO } from "date-fns";
import { enGB, fr, es, it, de, nl, pt } from "date-fns/locale";

export function jsonTradTs(json: Translation, lang?: string): string {
    const currentLang = lang ?? ENV.lang;

    if (typeof json[currentLang] !== 'undefined' && json[currentLang] !== '') {
        return json[currentLang];
    } else if (typeof json['en_GB'] !== 'undefined' && json['en_GB'] !== '') {
        return json['en_GB'];
    } else {
        for (const key in json) {
            if (typeof json[key] !== 'undefined' && json[key] !== '') {
                return json[key];
            }
        }
    }
    return '';
}


export function formatDateInLocale(date: Date, formatStr: string, lang: string = null): string {
    const currentLang = lang ?? ENV.lang.substr(0,2);
    const locales: any = { en: enGB, fr: fr, de: de, it: it, pt: pt, es: es, nl: nl };
    
    const formattedDate = format(date, formatStr, { locale: locales[currentLang] });
    return formattedDate;
}
